<template>
  <div class="oddsmatcher-selection">
    <div class="lock-message">
      <i class="bi bi-lock-fill lock-icon"></i>
      <p>This matched bet is locked. To view it, please log in. If you don't have an account, you can sign up for free.
        No
        card details required.</p>
      <div style="display: flex; gap: 1rem; margin-bottom: 1rem"><a href="https://aiprofit.uk/login"
                                                                    class="button button-small" datatype="inverted">Log
        In</a>
        <a href="https://aiprofit.uk/sign-up" class="button button-small">Sign Up</a></div>

      <p class="remove-sm-screen">If you don't want to, you can still use our oddsmatcher with fewer
        matched bets. Simply click the arrow to navigate on to the next matched bet!</p>
    </div>
  </div>
</template>

<style scoped>
.remove-sm-screen {
  display: none;
}

@media (min-width: 475px) {
  .remove-sm-screen {
    display: block;
  }
}


.oddsmatcher-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  padding: 2rem;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  height: 100%; /* Ensure it fills the available space */
  width: 68%; /* Ensure it fills the available space */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

.lock-message {
  width: 100%;
  height: 100%; /* Ensure it fills the available space */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center the content vertically */
  align-items: center; /* Center the content horizontally */
}

.lock-message p {
  margin-bottom: 1rem;
  font-size: 1rem;
  color: #333;
}

.lock-icon {
  font-size: 3rem; /* Size of the lock icon */
  margin-bottom: 1rem;
  color: var(--clr-primary-100);
}
</style>
<script setup>
</script>